import { useMemo } from "react";

function useUser(role) {
  const setUser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("tokenKey", user.token);
    role && localStorage.setItem("role", role);
  };
  const getUser = () => {
    const user = localStorage.getItem("user");
    if (!user) return null;
    return JSON.parse(user);
  };

  const getLoginProfile = () => {
    const login_profile = localStorage.getItem("login_profile");
    if (!login_profile) return null;
    return JSON.parse(login_profile);
  }

  const getToken = () => {
    return localStorage.getItem("tokenKey");
  };
  const getRole = () => {
    return localStorage.getItem("role");
  };
  const company = useMemo(() => {
    const companyDetails = JSON.parse(localStorage.getItem("user"));
    if (!companyDetails) return null;

    return companyDetails.company;
  }, []);

  const getPermission = () => {
    const permissions = localStorage.getItem("permission");
    const isApproved = JSON.parse(localStorage.getItem("is_approved"));
    return {
      allow: permissions,
      isApproved
    };
  }

  const getLoggedInUserDetail = () => {
    const user = getUser();
    const role = getRole();
    const userProfile = getLoginProfile();

    if (role === "admin") {
      const name = localStorage.getItem("name") || "";
      const email = localStorage.getItem("email") || "";
      return {
        name,
        email,
      };
    }

    // return {
    //   name: user?.company?.primary_contact_name || "",
    //   email: user?.email || "",
    // };

    // for corporate & one HR to multiple company flow
    return {
      name: userProfile?.name || "",
      email: userProfile?.email || "",
      is_multiple_company_mapped: userProfile?.is_multiple_company_mapped || ""
    };
  };

  return {
    getUser,
    getToken,
    getRole,
    setUser,
    company,
    getLoggedInUserDetail,
    getPermission
  };
}

export default useUser;
